/** Stable slug from heading text — shared by TOC and ReactMarkdown heading renderer. */
export function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/[*_`[\]]/g, "")
    .replace(/[^a-z0-9\u3000-\u9fff]+/g, "-")
    .replace(/^-|-$/g, "");
}
